import "./src/pages/style.scss";
import "./src/components/nav.scss";
import "./src/components/footer.scss";

// Les emails d'invitation/reinitialisation Netlify Identity redirigent
// toujours vers la racine du site (#invite_token=...), quelle que soit
// la page ou le widget est utilise. On l'initialise donc globalement
// pour qu'il detecte le token sur n'importe quelle page, puis on
// redirige vers /admin/ une fois la connexion etablie.
const TOKEN_HASH_PATTERN = /(confirmation|invite|recovery|email_change)_token=([^&]+)/

export const onClientEntry = () => {
    // Capture immediate et synchrone : le routeur de Gatsby peut modifier
    // window.location.hash de facon asynchrone juste apres, donc on ne
    // relit jamais location.hash plus tard, on garde cette valeur locale.
    const hash = window.location.hash || window.__NETLIFY_IDENTITY_HASH__ || ""
    const tokenMatch = hash.match(TOKEN_HASH_PATTERN)

    import("netlify-identity-widget").then((mod) => {
        const widget = mod.default || window.netlifyIdentity

        widget.on("login", () => {
            widget.close()
            if (window.location.pathname !== "/admin/") {
                window.location.assign("/admin/")
            }
        })
        widget.init()

        // On traite nous-memes le token (via l'API interne "store", exposee
        // publiquement par le widget) plutot que de compter sur sa detection
        // automatique du hash, qui se fait de facon asynchrone dans un iframe
        // et peut donc perdre la course contre le routeur.
        if (tokenMatch && widget.store) {
            widget.store.verifyToken(tokenMatch[1], tokenMatch[2])
            window.history.replaceState(null, "", window.location.pathname + window.location.search)
        }
    })
}